import firebase from 'firebase/app'
import 'firebase/firestore'
import config from '../config'

firebase.initializeApp(config.firebase)
// firebase.firestore().settings({ experimentalForceLongPolling: true })
// firebase.firestore().enablePersistence()
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
